import React, { useEffect, useState } from 'react';
import { array, bool, func, object, string } from 'prop-types';

import InfiniteScroll from 'react-infinite-scroll-component';

import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Popover from '@material-ui/core/Popover';

import SearchInput from '../containers/Global/SearchInput';

import { headerContent } from '../localization/en-us/headerContent';

import classes from './NavSelect.module.css';

const NavSelect = ({
    cancel,
    disabled,
    fetchChildren,
    entityType,
    isFromOverview,
    isFromHeader,
    isCompany,
    meta,
    parentId,
    reset,
    results,
    search,
    setTarget,
    targetId,
    targetName,
    title,
    isFromModal,
    isEquipment,
    isNavModal,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(1);
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (isFromOverview && parentId && ( entityType === 'equipment' || entityType === 'system')) {
            search(parentId, {mutateCompanyId: true});
        }
    }, [parentId]);

    useEffect(() => {
        if (results.length > 0) {
            setItems(
                results.map((item, index) => (
                    <ListItem
                        key={index}
                        onClick={() => handleMenuItemClick(item)}
                        classes={{
                            root: classes.ListItem
                        }}
                    >
                        {item.name}
                    </ListItem>
                ))
            );
        }
        else {
            setItems(
                [
                    <ListItem key={0} classes={{root: classes.ListItem}}>No Results Found</ListItem>
                ]
            );
        }
    }, [results]);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSearch = searchTerm => {
        setSearchValue(searchTerm);

        setPage(1);
        search(parentId, {
            searchFilter: searchTerm
        });
    };

    const handleMenuItemClick = async item => {
        await setTarget(item);
        
        if (!isNavModal) fetchChildren(item.id, { mutateCompanyId: true });

        if (isFromHeader) {
            reset();
        }

        handleClose();
    };

    const handleFetchMoreData = () => {
        if (!search) return;

        const nextPage = page + 1;

        search(parentId, {
            page:         nextPage,
            searchFilter: searchValue,
            loadMore:     true
        });

        setPage(nextPage);
    };

    const handleCancel = (e) => {
        e.stopPropagation();
        if (targetName) {
            cancel();
        }
    };

    const open = Boolean(anchorEl);
    const id = open ? 'nav-select-popover' : undefined;
    const entityName = targetName || `${headerContent.select}`;
    
    return (
        <div className={isFromModal ? classes.NavSelectModal : classes.NavSelect}>
            <Button
                className={classes.Button}
                aria-describedby={id}
                onClick={handleClick}
                disabled={(!results.length || disabled) && !open}
            >
                <div className={classes.Selector}>
                    <p>{title}</p>
                    <div className={classes.displayflex}>
                        <p>{ entityName }</p>
                        <p>{ targetName && !isCompany && isFromHeader ? 
                            <span className="close-icon" title={'Clear'}>
                                <span
                                    aria-hidden="true"
                                    role="button"
                                    tabIndex={0}
                                    className={`material-icons-outlined ${classes.md_14}`} 
                                    onClick={(e) => handleCancel(e)}
                                >
                                    cancel
                                </span>
                            </span> : ''}</p>
                    </div>
                </div>
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical:   'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical:   'top',
                    horizontal: 'left',
                }}
            >
                <div className={classes.List}>
                    {
                        search ?
                            <SearchInput
                                className={classes.SearchInput}
                                placeholder={`${headerContent.search} ${title}`}
                                search={handleSearch}
                                value={searchValue}
                                noRadius
                            /> :
                            null
                    }
                    <List>
                        <InfiniteScroll
                            dataLength={results.length}
                            next={handleFetchMoreData}
                            hasMore={meta.totalCount && meta.totalCount !== results.length && results.length !== 0}
                            loader={<h4>{`${headerContent.loading}`}</h4>}
                            height={200}
                        >
                            {items}
                        </InfiniteScroll>
                    </List>
                </div>
            </Popover>
        </div>
    );
};

NavSelect.defaultProps = {
    cancel:        bool,
    fetchChildren: () => {},
    isCompany:     false,
    isFromModal:   false,
    isFromHeader:  false,
    meta:          {},
    parentId:      '',
    reset:         () => {},
    results:       [],
    setTarget:     () => {},
    targetId:      '',
    targetName:    '',
    title:         'Title'
};

NavSelect.propTypes = {
    cancel:        func,
    fetchChildren: func,
    isCompany:     bool,
    isFromModal:   bool,
    isFromHeader:  bool,
    meta:          object,
    parentId:      string,
    reset:         func,
    results:       array,
    setTarget:     func,
    targetId:      string,
    targetName:    string,
    title:         string
};

export default NavSelect;
